import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseContainer } from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'med-private-website-container',
    templateUrl: './private-website-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivateWebsiteContainerComponent extends BaseContainer {
    constructor() {
        super();
    }
}
